var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c(
              "p",
              [
                _c(
                  "v-select",
                  _vm._b(
                    {
                      attrs: {
                        label: _vm.formatParameter.description,
                        items: _vm.items
                      },
                      model: {
                        value: _vm.str,
                        callback: function($$v) {
                          _vm.str = $$v
                        },
                        expression: "str"
                      }
                    },
                    "v-select",
                    _vm.$attrs,
                    false
                  )
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    disabled: !_vm.isDeleteAvailable,
                    color: "white",
                    title: "Reset to default format value"
                  },
                  on: { click: _vm.onChoiceClear }
                },
                [_c("v-icon", [_vm._v("mdi-undo")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }